var map = {
	"./en.json": [
		"gjDo",
		10
	],
	"./lib/en.json": [
		"awsI",
		11
	],
	"./lib/ru.json": [
		"Sxtj",
		12
	],
	"./ru.json": [
		"e63L",
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "W+yX";
module.exports = webpackAsyncContext;